import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';

const StatsSection = ({ stats}) => {


return (
<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Total Interviews</p>
<p className="text-3xl font-bold text-gray-900">{stats.total}</p>
</div>
<div className="bg-blue-100 p-3 rounded-full">
<Briefcase className="w-6 h-6 text-blue-600" />
</div>
</div>
</div>

<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Upcoming</p>
<p className="text-3xl font-bold text-gray-900">{stats.upcoming}</p>
</div>
<div className="bg-green-100 p-3 rounded-full">
<Clock className="w-6 h-6 text-green-600" />
</div>
</div>
</div>

<div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
<div className="flex items-center justify-between">
<div>
<p className="text-sm text-gray-600 mb-1">Mock Interviews</p>
<p className="text-3xl font-bold text-gray-900">{stats.mock}</p>
</div>
<div className="bg-purple-100 p-3 rounded-full">
<Brain className="w-6 h-6 text-purple-600" />
</div>
</div>
</div>
</div>
);
};

export default StatsSection;